import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img from "../../images/events/tablet.png";

function Subscribe(props) {
    return (
        <div className="subscribe tekrevol_gray_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="data-content">
                            <h2>Save The Data Our Programs Are Now Live</h2>
                            <p>Subscribe with Us Via Your Email So That You Don’t Miss Out On An Once In a Lifetime Events!</p>
                            <Link to="/contact"
                                  className="border_btn" aria-label="TekRevol Contact">Subscribe Now</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="data-img">
                            <LazyLoadImage
                                src={Img}
                                effect="blur" alt="subscribe" className="img-fluid"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Subscribe;